import React from 'react';

const BusinessInfo = () => {
    return (
        <div className="business-info">
            <h2>Στοιχεία Επιχείρησης</h2>
            <ul>
                <li>Τίτλος: «SCHOINAS CONSULTING ΜΟΝΟΠΡΟΣΩΠΗ Ι.Κ.Ε.»</li>
                <li>Διεύθυνση Έδρας: Kαλλιθέα [Λ.Συγγρού 196, Τ.Κ. 17671],</li>
                <li>Τηλέφωνο: +306988901906</li>
                <li>Αριθμός ΓΕΜΗ: 171955809000</li>
                <li>Αριθμός Μητρώου Επιμελητηρίου: 128518</li>
                <li>Αριθμός Φορολογικού Μητρώου: 802199784</li>
                <li>Κύρια Δραστηριότητα: [62011000] ΥΠΗΡΕΣΙΕΣ ΣΧΕΔΙΑΣΜΟΥ ΚΑΙ ΑΝΑΠΤΥΞΗΣ ΤΕΧΝΟΛΟΓΙΩΝ ΤΗΣ ΠΛΗΡΟΦΟΡΙΑΣ</li>
                <li>Δευτερεύουσες Δραστηριότητες: [62011104] ΥΠΗΡΕΣΙΕΣ ΔΗΜΙΟΥΡΓΙΑΣ ΙΣΤΟΣΕΛΙΔΩΝ ΣΤΟ ΔΙΑΔΙΚΤΥΟ,[70221300] ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΣΥΜΒΟΥΛΩΝ ΣΕ ΘΕΜΑΤΑ
                ΜΑΡΚΕΤΙΝΓΚ,[62011107] ΥΠΗΡΕΣΙΕΣ ΣΧΕΔΙΑΣΜΟΥ, ΥΠΟΣΤΗΡΙΞΗΣ ΚΑΙ ΟΛΟΚΛΗΡΩΣΗΣ ΣΥΣΤΗΜΑΤΟΣ ΛΟΓΙΣΜΙΚΟΥ</li>
                <li>Κωδικός Καταχώρισης Μητρώου: 171955809000</li>
                <li>Αρμόδια ΔΟΥ: ΚΑΛΛΙΘΕΑΣ</li>
                <li>Ημερομηνία Λήξεως Διαχειριστικής Περιόδου: 31/12/2023.</li>
                <li>Κεφάλαιο Εταιρείας: 1000 ευρω</li>
                <li>Εταίροι: ΣΧΟΙΝΑΣ ΚΩΝΣΤΑΝΤΙΝΟΣ</li>
            </ul>
        </div>
    );
};

export default BusinessInfo;

